<template>
  <div>
  <div class="row">
    <div class="col-sm-3 col-md-offset-1">
      <div class="form-group mb-0">
        <label id="select-payment">
          {{computeCaption(fields_en['select_payment_method'], $store.state.lang.value.toLowerCase())}}
        </label>
      </div>
    </div>

    <div class="col-sm-7">
      <div class="form-group gender-float">
        <el-radio-group
          @change="switchCashPayment"
          v-model="paymentMethod"
          size="small"
        >
          <el-radio-button value="true" inline label="card" :class="hide_pay_with_card ? 'display-none' : ''"> {{computeCaption(fields_en['pay_with_card'], $store.state.lang.value.toLowerCase())}}</el-radio-button>
          <el-radio-button inline label="site" :class="hide_pay_at_collection ? 'display-none' : ''">{{computeCaption(fields_en['pay_at_collection'], $store.state.lang.value.toLowerCase())}}</el-radio-button>
        </el-radio-group>
      </div>
    </div>
  </div>
  <div
    v-if="paymentMethod === 'card'"
    class="row"
  >
    <div class="col-md-10 col-md-offset-1" v-if=" $store.state.configs['AT_HOME_COLLECTION'] === 'false' && $store.state.configs['FORCE_PAYMENT_ON_REGISTRATION'] === 'false'">
      <h5 class="text-center">
        {{computeCaption(fields_en['after_registration_you_will_be_redirected_to_a_payment_page'], $store.state.lang.value.toLowerCase())}}
      </h5>
    </div>
  </div>
  </div>
</template>

<script>
import {RadioButton, RadioGroup} from 'element-ui'
import {TranslationsUtils} from '../../../../../../utils/Translations'

export default {
  components: {
    [RadioButton.name]: RadioButton,
    [RadioGroup.name]: RadioGroup
  },
  props: ['insurancePay'],
  mixins: [TranslationsUtils],
  data () {
    return {
      paymentMethod: '',
      model: {
        social_security_number: '',
        primary_insurance: '',
        primary_insurance_name_input: '',
        policy_number: '',
        group_number: '',
        relationship: '',
        insured_first_name: '',
        insured_last_name: '',
        insured_date_of_birth: '',
        insured_date_of_birth_pretty: '',
        insured_address_components: '',
        insured_gender: '',
        insurance_card_images: [],
        insurance_card_names: [],
        error_uninsured: '',
        note: ''
      },
      fields_en: {
        after_registration_you_will_be_redirected_to_a_payment_page: 'After registration you will be redirected to a payment page',
        select_payment_method: 'Select Payment Method',
        pay_with_card: 'Pay with card',
        pay_at_collection: 'Pay at collection'
      }
    }
  },
  beforeMount () {
    this.$emit('validateBill', true)
    this.populateModel('cash')
    if (!this.hide_pay_at_collection && !this.hide_pay_with_card) {
      this.paymentMethod = 'card'
    } else if (this.hide_pay_at_collection) {
      this.paymentMethod = 'card'
    } else if (this.hide_pay_with_card) {
      this.paymentMethod = 'site'
    }
    if (this.paymentMethod === 'card') {
      this.$store.state.cashPayment = 'card'
    }
  },
  methods: {
    switchCashPayment () {
      this.$store.state.cashPayment = ''
      if (this.paymentMethod === 'card') {
        this.$store.state.cashPayment = 'card'
      }
    },
    validate () {
      return true
    },
    resetAddressObject () {
      let resetAddress = {
        name: '',
        original_name: '',
        delivery_line_1: '',
        city_name: '',
        county: '',
        state_abbreviation: '',
        zipcode: '',
        plus4_code: '',
        county_fips: '',
        country: ''
      }
      return resetAddress
    },
    populateModel (type) {
      this.model.primary_insurance = type
      this.model.policy_number = type
      this.model.group_number = type
      this.model.insurance_card_image = ''
      this.model.social_security_number = ''
      this.model.relationship = 'Self'
      this.model.insured_first_name = this.$store.state.insuranceData.first_name
      this.model.insured_last_name = this.$store.state.insuranceData.last_name
      this.model.insured_date_of_birth = this.$store.state.insuranceData.dob
      this.model.insured_date_of_birth_pretty = this.$store.state.insuranceData.dob_pretty
      this.model.insured_gender = this.$store.state.insuranceData.gender
      this.model.insured_address_components = this.$store.state.insuranceData.addressComponents || this.resetAddressObject()
      this.model.insured_address2 = this.$store.state.insuranceData.address2
    }
  },
  computed: {
    hide_pay_at_collection () {
      return this.$store.state.configs.HIDE_PAY_AT_COLLECTION
    },
    hide_pay_with_card () {
      return this.$store.state.configs.HIDE_PAY_WITH_CARD
    }
  },
  watch: {
    'model': {
      handler: function (value) {
        this.$emit('updateModel', this.model)
      },
      deep: true
    }
  }
}
</script>
<style scoped>
.display-none{
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Utils/SubComponents/BillParts/Cash.vue